import { render, staticRenderFns } from "./BattleCrews.vue?vue&type=template&id=443eb56d&scoped=true"
import script from "./BattleCrews.vue?vue&type=script&lang=js"
export * from "./BattleCrews.vue?vue&type=script&lang=js"
import style0 from "./BattleCrews.vue?vue&type=style&index=0&id=443eb56d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443eb56d",
  null
  
)

export default component.exports